import {
  jb_focus_fly_css_default
} from "./chunk.C4URUTP4.js";
import {
  focusable
} from "./chunk.A5NJZLW3.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  getAllParents,
  isiOS
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-focus-fly/jb-focus-fly.ts
var JbFocusFly = class extends i {
  constructor() {
    super(...arguments);
    this.defaultPadding = 4;
    this.validKeys = ["Escape", "Tab", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space"];
    this._colorCache = /* @__PURE__ */ new Map();
    this._defaultPaddingAdd = 2;
    this._flyContainerContent = "";
    this._flyTweak = [];
    this._getAndAnimateFocusBound = this._getAndAnimateFocus.bind(this);
    this._handleKeyboardEventsBound = this._handleKeyboardEvents.bind(this);
    this._hideFlyBound = this._hideFly.bind(this);
    this._inDialogContext = false;
    this._mediaQueryBound = (e3) => {
      document.documentElement.style.setProperty("scroll-behavior", e3.matches ? "auto" : "smooth");
    };
    this._motionMediaQuery = null;
    this._onDarkBackground = false;
    this._showFlyBound = this._showFly.bind(this);
    this._visible = false;
  }
  connectedCallback() {
    if (isiOS()) {
      document.body.style.setProperty("--focus-outline-style", "none");
    }
    super.connectedCallback();
    if (!this.hasAttribute("popover")) {
      this.setAttribute("popover", "manual");
    }
    this._motionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!this._motionMediaQuery.matches && !window.location.hash) {
      document.documentElement.style.setProperty("scroll-behavior", "smooth");
    }
    this._motionMediaQuery.addEventListener("change", this._mediaQueryBound);
    window.addEventListener("blur", this._hideFlyBound);
    window.addEventListener("keyup", this._handleKeyboardEventsBound);
    window.addEventListener("mousedown", this._hideFlyBound);
    document.addEventListener("jb-focus-fly:reset", this._getAndAnimateFocusBound);
    document.addEventListener("jb-focus-fly:hide", this._hideFlyBound);
    document.addEventListener("jb-focus-fly:show", this._showFlyBound);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this._motionMediaQuery?.removeEventListener("change", this._mediaQueryBound);
    window.removeEventListener("blur", this._hideFlyBound);
    window.removeEventListener("keyup", this._handleKeyboardEventsBound);
    window.removeEventListener("mousedown", this._hideFlyBound);
    document.removeEventListener("jb-focus-fly:reset", this._getAndAnimateFocusBound);
    document.removeEventListener("jb-focus-fly:hide", this._hideFlyBound);
    document.removeEventListener("jb-focus-fly:show", this._showFlyBound);
  }
  firstUpdated() {
    this._setFocusStyles();
  }
  _applyStyleToRoot(root) {
    if (!JbFocusFly._focusStyleSheet || JbFocusFly._styledRoots.has(root)) return;
    root.adoptedStyleSheets.push(JbFocusFly._focusStyleSheet);
    JbFocusFly._styledRoots.add(root);
  }
  _callPopoverMethod(method) {
    if (!(method in this)) return;
    try {
      this[method]();
    } catch {
    }
  }
  _getActiveElement(root) {
    this._applyStyleToRoot(root);
    const elm = root.activeElement;
    if (!elm) return null;
    if (!this._customPadding && elm.dataset.flyPadding) {
      this._customPadding = parseInt(elm.dataset.flyPadding, 10);
    }
    if (!elm.shadowRoot?.activeElement) {
      return elm;
    }
    return this._getActiveElement(elm.shadowRoot);
  }
  _getAndAnimateFocus() {
    this._flyContainerVisible = false;
    this._customPadding = void 0;
    this._flyTweak = [];
    let elm = this._getActiveElement(document);
    if (!elm || elm.tagName === "BODY" || elm.getAttribute("type") === "hidden") {
      this._visible = false;
      return;
    }
    const prnts = getAllParents(elm);
    let inDialogContext = false;
    prnts.forEach((prnt) => {
      const parentElement = prnt;
      if (parentElement.tagName === "DIALOG") {
        inDialogContext = true;
      }
      if (parentElement.dataset?.flyCatcher !== void 0) {
        elm = prnt;
        return;
      }
      if (parentElement.dataset?.flyContainer !== void 0) {
        let containerTweak;
        this._flyContainerContent = parentElement.dataset.flyContainer;
        if (parentElement.dataset?.flyTweak) {
          containerTweak = parentElement.dataset.flyTweak.split(",");
        }
        if (containerTweak?.length !== 4) {
          containerTweak = ["0", "0", "0", "0"];
        }
        const containerRect = parentElement.getBoundingClientRect();
        this._flyContainer.style.translate = `${containerRect.left + (containerTweak[1] ? parseInt(containerTweak[1], 10) : 0)}px ${containerRect.top + (containerTweak[3] ? parseInt(containerTweak[3], 10) : 0)}px`;
        this._flyContainer.style.width = `${containerRect.width + (containerTweak[2] ? parseInt(containerTweak[2], 10) : 0)}px`;
        this._flyContainer.style.height = `${containerRect.height + (containerTweak[0] ? parseInt(containerTweak[0], 10) : 0)}px`;
        this._flyContainerVisible = true;
      }
    });
    if (inDialogContext && !this._inDialogContext) {
      this._callPopoverMethod("hidePopover");
      this._callPopoverMethod("showPopover");
    }
    this._inDialogContext = inDialogContext;
    if (this._flyTweak.length === 0 && elm.dataset?.flyTweak) {
      this._flyTweak = elm.dataset.flyTweak.split(",");
    }
    this._onDarkBackground = this._parseColor(this._getElementBackground(elm)).hsp < 127.5;
    const elmRect = elm.getBoundingClientRect();
    let horizontalAdd;
    let horizontalTranslate;
    let verticalAdd;
    let verticalTranslate;
    if (this._flyTweak.length === 4) {
      verticalAdd = parseInt(this._flyTweak[0] ?? "0", 10);
      verticalTranslate = parseInt(this._flyTweak[1] ?? "0", 10);
      horizontalAdd = parseInt(this._flyTweak[2] ?? "0", 10);
      horizontalTranslate = parseInt(this._flyTweak[3] ?? "0", 10);
    } else {
      horizontalAdd = 0;
      horizontalTranslate = 0;
      verticalAdd = 0;
      verticalTranslate = 0;
    }
    const flyPadding = (this._customPadding ?? this.defaultPadding) + this._defaultPaddingAdd;
    this.style.setProperty("--_focus-fly-padding", `${flyPadding}px`);
    this._focusFlyElement.style.translate = `${elmRect.left + horizontalTranslate}px ${elmRect.top + verticalTranslate}px`;
    this._focusFlyElement.style.width = `${elmRect.width + horizontalAdd + 2 * (flyPadding + 2)}px`;
    this._focusFlyElement.style.height = `${elmRect.height + verticalAdd + 2 * (flyPadding + 2)}px`;
  }
  _getElementBackground(element) {
    let elm = this._getParentOrHost(element);
    while (elm) {
      const bg = window.getComputedStyle(elm).backgroundColor;
      if (bg && this._parseColor(bg).opacity > 0.2) {
        return bg;
      }
      elm = this._getParentOrHost(elm);
    }
    return "rgb(255,255,255)";
  }
  _getParentOrHost(element) {
    return element.parentElement || (element.getRootNode() instanceof ShadowRoot ? element.getRootNode().host : null);
  }
  _handleKeyboardEvents(evt) {
    if (!this.validKeys.includes(evt.code)) return;
    if (isiOS()) {
      JbFocusFly._focusStyleSheet?.replaceSync("*:focus, *:focus-visible { --focus-outline-style: auto !important; }");
      return;
    }
    if (evt.code === "Tab") {
      this._showFlyBound();
    }
  }
  _hideFly() {
    this._visible = false;
    this._inDialogContext = false;
    if (this._intervalRunner !== void 0) {
      cancelAnimationFrame(this._intervalRunner);
      this._intervalRunner = void 0;
    }
    this._callPopoverMethod("hidePopover");
  }
  _isVisible() {
    return this._visible;
  }
  _parseColor(color) {
    if (this._colorCache.has(color)) {
      return this._colorCache.get(color);
    }
    const tempElement = document.createElement("div");
    tempElement.style.color = color;
    tempElement.style.position = "absolute";
    document.body.appendChild(tempElement);
    const computedColor = window.getComputedStyle(tempElement).color;
    document.body.removeChild(tempElement);
    const rgbaMatch = computedColor.match(/rgba?\((\d+), (\d+), (\d+)(?:, (\d+(\.\d+)?))?\)/);
    if (!rgbaMatch) {
      return { r: 255, g: 255, b: 255, opacity: 1, hsp: 255 };
    }
    const opacity = rgbaMatch[4] ? parseFloat(rgbaMatch[4]) : 1;
    const hsp = Math.sqrt(
      0.299 * parseFloat(rgbaMatch[1]) ** 2 + 0.587 * parseFloat(rgbaMatch[2]) ** 2 + 0.114 * parseFloat(rgbaMatch[3]) ** 2
    );
    const result = {
      r: parseInt(rgbaMatch[1], 10),
      g: parseInt(rgbaMatch[2], 10),
      b: parseInt(rgbaMatch[3], 10),
      opacity,
      hsp
    };
    this._colorCache.set(color, result);
    return result;
  }
  _setFocusStyles() {
    if (!JbFocusFly._focusStyleSheet) {
      JbFocusFly._focusStyleSheet = new CSSStyleSheet();
      JbFocusFly._focusStyleSheet.replaceSync("*:focus, *:focus-visible { outline-style: none !important;  }");
    }
    this._applyStyleToRoot(document);
    const tabbies = focusable(document.body, { getShadowRoot: true });
    tabbies.forEach((tab) => {
      const root = tab.getRootNode();
      if (root instanceof ShadowRoot) {
        this._applyStyleToRoot(root);
      }
    });
  }
  _showFly() {
    if (!this._isVisible()) {
      document.dispatchEvent(new CustomEvent("lazyloading:load", { composed: true, bubbles: true }));
    }
    if (!this._inDialogContext && document.querySelector("dialog[open]")) {
      this._inDialogContext = true;
    }
    this._visible = true;
    this._callPopoverMethod("showPopover");
    this._setFocusStyles();
    if (this._intervalRunner === void 0) {
      const loop = () => {
        this._getAndAnimateFocus();
        this._intervalRunner = requestAnimationFrame(loop);
      };
      this._intervalRunner = requestAnimationFrame(loop);
    }
  }
  render() {
    return b`<div
        id="focusfly"
        aria-hidden="true"
        class=${e2({ ondark: this._onDarkBackground, visible: this._visible })}
        part="fly"
      ></div>
      <div
        id="flycontainer"
        aria-hidden="true"
        class=${e2({ ondark: this._onDarkBackground, visible: this._visible && this._flyContainerVisible })}
        part="container"
      >
        ${this._flyContainerContent ? b`<p part="helpcontainer">${this._flyContainerContent}</p>` : A}
      </div>`;
  }
};
JbFocusFly.styles = jb_focus_fly_css_default;
JbFocusFly._focusStyleSheet = null;
JbFocusFly._styledRoots = /* @__PURE__ */ new WeakSet();
__decorateClass([
  n({ type: Number })
], JbFocusFly.prototype, "defaultPadding", 2);
__decorateClass([
  n({ type: Array })
], JbFocusFly.prototype, "validKeys", 2);
__decorateClass([
  e("#flycontainer")
], JbFocusFly.prototype, "_flyContainer", 2);
__decorateClass([
  r()
], JbFocusFly.prototype, "_flyContainerContent", 2);
__decorateClass([
  r()
], JbFocusFly.prototype, "_flyContainerVisible", 2);
__decorateClass([
  e("#focusfly")
], JbFocusFly.prototype, "_focusFlyElement", 2);
__decorateClass([
  r()
], JbFocusFly.prototype, "_onDarkBackground", 2);
__decorateClass([
  r()
], JbFocusFly.prototype, "_visible", 2);
JbFocusFly = __decorateClass([
  customElement("jb-focus-fly")
], JbFocusFly);

export {
  JbFocusFly
};
